// GPH Expert Intelligence Core — Logs internos (PDS §18).
// Ring buffer em memória com os campos de decisão de cada turno.
// Nunca exposto na UI; console.debug apenas em desenvolvimento.

const MAX_ENTRIES = 200;
const buffer = [];

export const logAgentTurn = (entry = {}) => {
  const record = {
    ts: new Date().toISOString(),
    intent: entry.intent || null,
    confidence: entry.confidence ?? null,
    slots: entry.slots || null,
    contextUsed: entry.contextUsed || null,
    skillChosen: entry.skillChosen || null,
    researchDecision: entry.researchDecision || null,
    sources: entry.sources ?? null,
    evidenceScore: entry.evidenceScore ?? null,
    schemaType: entry.schemaType || null,
    guardApplied: entry.guardApplied || null,
    fallbackUsed: entry.fallbackUsed || false,
    error: entry.error || null
  };
  buffer.push(record);
  if (buffer.length > MAX_ENTRIES) buffer.shift();
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[GPH-LOG]', record);
  }
  return record;
};

export const getAgentLog = () => [...buffer];

export const clearAgentLog = () => { buffer.length = 0; };

export default logAgentTurn;
